import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6c5cb501"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-box"
};
const _hoisted_3 = {
  class: "dialog-parcel"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "news-title"
};
const _hoisted_6 = {
  class: "news-description"
};
const _hoisted_7 = {
  key: 1
};
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import newsMessageDialog from '../../news-message/index.vue';
import { delReplyById, getAllNewsReplyById } from '@/api/greeting';

// 图文详情是否显示

export default {
  __name: 'index',
  props: {
    greetingList: {
      type: Array,
      required: true
    },
    isSelectNewsVisible: {
      type: Boolean,
      required: false
    }
  },
  emits: ['changeSelectNewsVisible', 'getData', 'editGreetingHandler', 'changeDialogVisible', 'checkNewsPublishHandler'],
  setup(__props, {
    emit: __emit
  }) {
    const isNewsVisible = ref(false);
    const newsId = ref(0);

    /**
     * 点击查看图文详情
     */
    const onSearchInfoHandler = row => {
      newsId.value = row.id;
      isNewsVisible.value = true;
    };
    const route = useRoute();
    const props = __props;
    const emits = __emit;
    const {
      path
    } = route.params;

    // 当前页
    const currentPage = ref(1);

    // 图文自动回复列表
    const newsList = ref([]);

    // 获取图文自动回复列表
    const getNewsData = async () => {
      var _newsList$value, _res$item$;
      if ((_newsList$value = newsList.value) !== null && _newsList$value !== void 0 && _newsList$value.length) return;
      const res = await getAllNewsReplyById(path, currentPage.value);
      newsList.value = res === null || res === void 0 || (_res$item$ = res.item[0]) === null || _res$item$ === void 0 ? void 0 : _res$item$.content.news_item;
    };
    watch(() => props.isSelectNewsVisible, val => {
      if (val) getNewsData();
    });

    /**
     * 点击选择图文素材
     */
    const checkNewsPublishHandler = item => {
      emits('checkNewsPublishHandler', item);
    };

    /**
     * 删除回复消息
     */
    const delGreetingHandler = async raw => {
      try {
        await ElMessageBox.confirm('确认删除吗', '温馨提示', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });

        // 如果该租户的子诊所数量为0的话
        await delReplyById(raw.id);
        emits('getData');
        ElMessage({
          message: '删除成功',
          type: 'success'
        });
      } catch (error) {}
    };

    /**
     * 修改
     */
    const editGreetingHandler = raw => {
      emits('changeDialogVisible', true);
      // form.value = { ...row, isChain: Boolean(row.isChain) }
      emits('editGreetingHandler', raw);
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_table, {
        data: __props.greetingList,
        border: "",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          type: "index",
          width: "80"
        }), _createVNode(_component_el_table_column, {
          prop: "keyword",
          label: "关键字",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.dateFilter(row.createTime)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "modifyTime",
          label: "修改时间"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.dateFilter(row.modifyTime)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "250"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => onSearchInfoHandler(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 详情 ")]),
            _: 2
          }, 1032, ["onClick"]), row.keyword !== 'welcome' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            size: "small",
            onClick: $event => editGreetingHandler(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 修改 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), row.keyword !== 'welcome' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "danger",
            size: "small",
            onClick: $event => delGreetingHandler(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createVNode(newsMessageDialog, {
        modelValue: isNewsVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isNewsVisible.value = $event),
        newsId: newsId.value
      }, null, 8, ["modelValue", "newsId"]), _createVNode(_component_el_dialog, {
        title: "选择素材",
        "model-value": __props.isSelectNewsVisible,
        onClosed: _cache[1] || (_cache[1] = $event => _ctx.$emit('changeSelectNewsVisible', false)),
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => {
          var _newsList$value2;
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_newsList$value2 = newsList.value) !== null && _newsList$value2 !== void 0 && _newsList$value2.length ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(newsList.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "news-item",
              onClick: $event => checkNewsPublishHandler(item)
            }, [_createVNode(_component_el_image, {
              src: item.thumb_url,
              class: "img"
            }, null, 8, ["src"]), _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.digest), 1)], 8, _hoisted_4);
          }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无素材"))])])];
        }),
        _: 1
      }, 8, ["model-value"])], 64);
    };
  }
};